module.exports = __webpack_public_path__ + "img/ReturnBack.a7a75587.svg";